module.exports = __webpack_public_path__ + "static/media/beechtree_logo.550f4059.png";